import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  Season,
  SeasonStandings,
  CreateSeasonRequest,
} from '@spectrace/shared/src/types';

@Injectable({
  providedIn: 'root',
})
export class SeasonService {
  private apiUrl = `${environment.apiUrl}/seasons`;

  constructor(private http: HttpClient) {}

  createSeason(teamId: string, data: CreateSeasonRequest): Observable<Season> {
    return this.http.post<Season>(this.apiUrl, { teamId, ...data });
  }

  getSeasonsByTeam(teamId: string): Observable<Season[]> {
    return this.http.get<Season[]>(`${this.apiUrl}/team/${teamId}`);
  }

  getSeasonById(id: string): Observable<Season> {
    return this.http.get<Season>(`${this.apiUrl}/${id}`);
  }

  getSeasonStandings(id: string): Observable<SeasonStandings> {
    return this.http.get<SeasonStandings>(`${this.apiUrl}/${id}/standings`);
  }
}
